import { useCurrentLanguage } from '@app/i18n';
import {
  PlusIcon,
  PolicyIcon,
  ClockIcon,
  SellingIcon,
  CompanyIcon,
} from '@stockx/icons';
import { useTranslation } from 'react-i18next';
import useLinkState from './useLinkState';

const useSubNav = () => {
  const { t } = useTranslation();
  const { urlPrefix } = useCurrentLanguage();
  const linkState = useLinkState();

  return [
    {
      Icon: PlusIcon,
      label: t('sell_new_listing'),
      to: { pathname: '/sell', state: linkState },
    },
    {
      Icon: PolicyIcon,
      label: t('sell_current_listing'),
      to: { pathname: '/selling?status=current', state: linkState },
    },
    {
      Icon: ClockIcon,
      label: t('sell_pending_sales'),
      to: { pathname: '/selling?status=pending', state: linkState },
    },
    {
      Icon: SellingIcon,
      label: t('sell_history'),
      to: { pathname: '/selling?status=history', state: linkState },
    },
    {
      Icon: CompanyIcon,
      label: t('sell_professional_tools'),
      to: `https://stockx.com/about${urlPrefix}professionalsellers`,
      isExternal: true,
    },
  ];
};

export default useSubNav;
